import { LitElement, html, css } from 'lit'

//Handles menu state and animated border indicating selected menu item.
//Opening and closing of the menu is handled by the indivdual modal components.
class DesktopMenu extends LitElement {
  static styles = css`
    :host {
      display: block;
    }

    .border {
      display: block;
      height: 3px;
      background: hsl(var(--theme-200));
      width: 0;
      position: absolute;
      left: 0;
      bottom: -3px;
      z-index: 1004;
      opacity: 0;
    }

    .border--init {
      transition: all 300ms ease-in-out;
    }

    .border--visible {
      opacity: 1;
    }
  `
  static properties = {
    state: { type: String, reflect: true },
  }

  constructor() {
    super()
    this.state = 'closed'
    
  }
  
  resetBorderPosition() {
    if (this.state === 'open') {
      this._border.style.width = this.querySelector('[aria-expanded="true"]').offsetWidth + 'px'
      this._border.style.left = this.querySelector('[aria-expanded="true"]').offsetLeft + 'px'
    }
  }

  render() {
    return html`
      <slot></slot>
      <span class='border'></span>
    `
  }

  firstUpdated() {
    this._border = this.shadowRoot.querySelector('.border')

    this.addEventListener('modal-opening', (e) => {
      if (this.state === 'closed') {
        this.state = 'opening'
      }
    })
    this.addEventListener('modal-closing', (e) => {
      if (!this.querySelector('[aria-expanded="true"]')) {
        this.state = 'closing'
        this._border.classList.remove('border--visible')
      }
    })
    this.addEventListener('modal-opened', (e) => {
      this.state = 'open'
      window.addEventListener('resize', this.resetBorderPosition.bind(this))
      document.querySelector('.main').setAttribute('inert', '')
      document.querySelector('.footer').setAttribute('inert', '')
    })
    this.addEventListener('modal-closed', (e) => {
      if (!this.querySelector('[aria-expanded="true"]')) {
        this.state = 'closed'
        this._border.classList.remove('border--init')
        this._border.style.width = 0
        this._border.style.left = 0
        window.removeEventListener('resize', this.resetBorderPosition.bind(this))
        document.querySelector('.main').removeAttribute('inert', '')
        document.querySelector('.footer').removeAttribute('inert', '')
      }
    })
    //Create observer that checks when aria-expanded is set to true on the trigger
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes') {
          if (mutation.attributeName === 'aria-expanded') {
            if (mutation.target.getAttribute('aria-expanded') === 'true') {
              setTimeout(() => {
                this._border.style.width = mutation.target.offsetWidth + 'px'
                this._border.style.left = mutation.target.offsetLeft + 'px'
              })
            }
            if (this.state === 'open' || this.state === 'opening') {
              this._border.classList.add('border--visible')
            }
            if (this.state === 'open') {
              this._border.classList.add('border--init')
            } else {
              this._border.classList.remove('border--init')
            }
          }
        }
      })
    })
    //Start observing the trigger
    const triggers = this.querySelectorAll('[aria-controls]')
    triggers.forEach((trigger) => {
      observer.observe(trigger, {
        attributes: true,
      })
    })
  }
  connectedCallback() {
    super.connectedCallback()
    this.currentPage()
    this.triggers = this.querySelectorAll('[aria-controls]')
    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        this.setPositionHeader()
      })
    })
    window.addEventListener('resize', this.setPositionHeader)
  }

    setPositionHeader = () => {
      const zoom = ((window.outerWidth - 10) / window.innerWidth) * 100 > 150
      const header = document.querySelector('.header')
      if (this.querySelector('[aria-expanded="true"]') !== null && zoom) {
        header.style.position = 'relative'
      } else {
        header.style.position = 'sticky'
      }
    }

    currentPage = () => {
      const currentNav = document.querySelectorAll(`[data-current-nav]`)
      const query = window.location.pathname.split('/')[1]

      for (const nav of currentNav) {
        const href = nav.getAttribute('href').replace(/\//g, '')
        if (href === query) {
          nav.setAttribute('data-current-nav', 'true')
        } else {
          nav.setAttribute('data-current-nav', 'false')
        }
      }
    }
  }

  customElements.define('desktop-menu', DesktopMenu)
